<template>
  <section v-loading="loading" style="padding:0px">
    <div id="bmap"></div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      points: [],
      center: { lng: 105.0, lat: 38.0 },
      guid: "",
      params: {
        uid: ""
      },
      loading: true,
      map: null,
      markers: []
    };
  },
  methods: {
    addDevPoints: function() {
      // const colletpoints = [];
      // const pointdes = [];
      let self = this;
      this.$api
        .post("Device", this.params)
        .then(res => {
          self.points.length = 0;
          self.loading = true;
          if (res.status == 200) {
            var devs = res.data.Data.list;
            var des = "";
            var pos = "";
            for (var i = 0; i < devs.length; i++) {
              if (
                devs[i].dev_lng != null &&
                devs[i].dev_lng != undefined &&
                devs[i].dev_lat != null &&
                devs[i].dev_lat != undefined
              ) {
                pos = new BMap.Point(devs[i].dev_lng, devs[i].dev_lat);
                des =
                  "<html><table class='mytable'><tr><th colspan='2' class='table_th'>设备信息</th></tr>" +
                  "<tr><td>设备名称</td><td><span>" +
                  devs[i].dev_name +
                  "</span></td></tr>" +
                  "<tr><td>设备类型</td><td><span>" +
                  devs[i].type_name +
                  "[" +
                  devs[i].type_code +
                  "]</span></td></tr>" +
                  "<tr><td>设备地址</td><td><span>" +
                  devs[i].dev_address +
                  "</span></td></tr>" +
                  // "<tr><td>未处理报警</td><td>" +
                  // devs[i].alarmcount +
                  // "</td></tr>" +
                  // "<tr><td>变量数</td><td>" +
                  // devs[i].varcount +
                  // "</td></tr>" +
                  "<tr><td><a href='" +
                  "detail?id=" +
                  devs[i].guid +
                  "' target='_blank'" +
                  ">监控页面</a></td><td></td></tr>" +
                  "</table></html>";

                self.points.push({
                  guid: devs[i].guid,
                  position: pos,
                  content: des
                });
              }
            }
            if (self.guid != null && self.guid != "") {
              //转换缩放中心
              self.center = {
                lng: self.$route.query.lng,
                lat: self.$route.query.lat
              };
            } else if (self.points.length > 0) {
              //转换缩放中心
              self.center = {
                lng: self.points[0].position.lng,
                lat: self.points[0].position.lat
              };
            }
            var pp = new BMap.Point(self.center.lng, self.center.lat);
            self.map.centerAndZoom(pp, 5); //设置中心点和显示级别。中国。
            self.addMarker(self.points);
            self.loading = false;
          }
        })
        .catch(err => {
          self.points.length = 0;
          self.loading = false;
          //console.log(err);
        });
    },
    getPageUrl(guid) {
      return this.$store.state.pageurl + "/detail?" + guid;
    },
    addMarker(points) {
      let self = this;
      // 创建标注对象并添加到地图
      this.markers = [];
      for (var i = 0, pointsLen = points.length; i < pointsLen; i++) {
        var marker = new BMap.Marker(points[i].position);
        this.map.addOverlay(marker);
        this.markers.push(marker);
        //给标注点添加点击事件。使用立即执行函数和闭包
        (function() {
          var thePoint = points[i];
          marker.addEventListener("click", function() {
            self.showInfo(this, thePoint);
          });
        })();
      }
      if (this.markers.length > 0) {
        this.markers[0].V.click();
        this.map.centerAndZoom(this.markers[0].point, 5); //设置中心点和显示级别。中国。
      }
    },
    //显示信息窗口，显示标注点的信息。
    showInfo(thisMaker, point) {
      var infoWindow = new BMap.InfoWindow(point.content); // 创建信息窗口对象
      thisMaker.openInfoWindow(infoWindow); //图片加载完毕重绘infowindow
    },
    loadMap() {
      this.map = new BMap.Map("bmap");
      var pp = new BMap.Point(this.center.lng, this.center.lat);
      this.map.centerAndZoom(pp, 5); //设置中心点和显示级别。中国。
      this.map.enableScrollWheelZoom(); //滚轮放大缩小。
      //添加缩放平移控件
      this.map.addControl(new BMap.NavigationControl());
      //添加比例尺控件
      this.map.addControl(new BMap.ScaleControl());
      //添加地图类型控件
      this.map.addControl(
        new BMap.MapTypeControl({
          mapTypes: [BMAP_NORMAL_MAP, BMAP_SATELLITE_MAP, BMAP_HYBRID_MAP]
        })
      );
      //添加地图类型控件
      this.map.addControl(new BMap.OverviewMapControl());
    }
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.myheight = window.innerHeight - 125 + "px";
      })();
    };
  },
  created() {
    this.guid = this.$route.query.id;
    this.params.uid = this.$store.state.userInfo.id;
    this.$nextTick(() => {
      this.loadMap();
      this.addDevPoints();
    });
  }
};
</script>

<style>
#bmap{
  overflow:hidden;
  height:calc(100vh - 115px);
  border: 1px solid #ddd;
  border-radius: 5px;
  background:#fff
}
.mytable {
  width: 100%;
  font-size: 14px;
  color: #666;
  /* border-collapse: collapse; */
  margin: 0 auto;
  text-align: left;
  border: 1px solid #cad9ea;
}
.table_th {
  background-color: #cce8eb;
  font-size: 15px;
}
.mytable /deep/ span {
  margin-left: 10px;
}
</style>
